<div *ngIf="control">
  <span
    class="text-xs text-r300 flex items-center gap-1"
    *ngIf="control.invalid && control.dirty && isDisplayError"
  >
    <i class="ph ph-warning-circle text-sm"></i>{{ showError }}
  </span>
</div>
